import spinner from './Spinner.gif'

const Loader= ()=> {
    return (
        <div>
           <img src={spinner} alt="loading....."></img>
        </div>
    )
}

export default Loader
